import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/Card/Card';
import { cn } from '@/utils';
import type { PropsWithChildren } from 'react';

export const GenericFormScreen = ({
  children,
  title,
  description,
  leftActionElement,
  rightActionElement,
  contentClassName = '',
}: PropsWithChildren<{
  title: string;
  description?: string;
  leftActionElement?: React.ReactNode;
  rightActionElement?: React.ReactNode;
  contentClassName?: string;
}>) => {
  return (
    <Card className='tablet:w-[460px] desktop:w-[480px] max-tablet:p-5 max-tablet:pb-0 max-tablet:h-[calc(100vh-76px)] tablet:min-h-[588px] tablet:max-h-[684px] h-screen w-full'>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className={cn('tablet:mb-6 mb-8 overflow-auto', contentClassName)}>{children}</CardContent>
      {(!!leftActionElement || !!rightActionElement) && (
        <CardFooter isStickyOnMobile className='flex gap-3 *:w-full'>
          {leftActionElement}
          {rightActionElement}
        </CardFooter>
      )}
    </Card>
  );
};
